import { makeFragmentData } from '@packages/gql/generated/shopping';
import type { Config } from '@packages/config';
import {
  TaxHintFragmentFragmentDoc,
  type TaxHintFragmentFragment,
} from '@packages/gql/generated/shopping/graphql';

const taxHint: Config['product']['taxHint'] = {
  hideAdditionalDeliveryInfo: false,
  modalContent: {
    DEFAULT: {
      link: 'delivery_default',
    },
    L: {
      link: 'delivery_spedition-layer-L',
    },
    S: {
      link: 'delivery_spedition-layer-S',
    },
  },
};
export const taxHintConfigMock = {
  product: {
    taxHint,
  },
};

export const taxHintDataMock: TaxHintFragmentFragment = { deliverySize: 'DEFAULT' };

export function getTaxHintFragmentedData(data?: TaxHintFragmentFragment) {
  return makeFragmentData(data || taxHintDataMock, TaxHintFragmentFragmentDoc);
}
